import { ReactNode } from "react";

import { AbstractRow } from "./RtTypes";

export type RtColumnFixedSide = "left" | "right";

export type RtColumnCapabilities = {
  configurable?: boolean;
  resizable?: boolean;
  fixed?: RtColumnFixedSide;
};

export type RtColumnDef = {
  key: string;
  title: ReactNode;
  shortTitle?: string; // может быть полезен для настроек
  footer?: ReactNode;
  minWidth?: number;
  width?: number | string;
  sort?: boolean;
  align?: "center" | "left" | "right";
  cellClassName?: string;
  capabilities?: RtColumnCapabilities;
};

export const isColumnConfigurable = (
  column: RtColumnDef | undefined,
): boolean => column?.capabilities?.configurable !== false;

export type RtColumn<TRow extends AbstractRow> = RtColumnDef & {
  subColumns?: RtColumn<TRow>[];
  render?: (row: TRow) => ReactNode;
};
